import randomBytes from "randombytes";

export const generateHex = () => {
    const buf = randomBytes(20);
    return buf.toString("hex");
};
